import React from 'react';
import Logo from './icons/logo';

import './navbar.css';
import { Link } from 'gatsby';
import { useOnClickOutside } from '../hooks/useOnClickOutside';

export default function Navbar(): JSX.Element {
  const ref = React.useRef(null);
  const secondRef = React.useRef(null);
  const [isSidebarVisible, setIsSidebarVisible] = React.useState(false);
  useOnClickOutside(ref, secondRef, () => setIsSidebarVisible(false));
  return (
    <nav className="navbar fixed-top">
      <div className="navbar-brand">
        <Link to="/" className="navbar-link">
          <Logo className="navbar-brand-logo" />
          <span className="d-none d-sm-inline navbar-brand-text">Kancelaria adwokacka</span>
        </Link>
      </div>
      <button
        ref={secondRef}
        type="button"
        aria-label="Mapa strony"
        className="navbar-menu-toggle"
        onClick={() => setIsSidebarVisible(!isSidebarVisible)}
      >
        {isSidebarVisible ? (
          <React.Fragment>&#9587;</React.Fragment>
        ) : (
          <React.Fragment>&#9776;</React.Fragment>
        )}
      </button>
      <div
        className="navbar-sidebar"
        ref={ref}
        style={{
          width: isSidebarVisible ? '250px' : '0px',
        }}
      >
        <div className="navbar-sidebar-item">
          <Link to="/" className="navbar-sidebar-link" onClick={() => setIsSidebarVisible(false)}>
            Strona&#8239;główna
          </Link>
        </div>
        <div className="navbar-sidebar-item">
          <Link to="/kancelaria" className="navbar-sidebar-link">
            Kancelaria
          </Link>
        </div>
        <div className="navbar-sidebar-item">
          <Link to="/kontakt" className="navbar-sidebar-link">
            Kontakt
          </Link>
        </div>
      </div>
    </nav>
  );
}
